const { h, render, Component } = require('preact');

class DealImage extends Component {
  constructor(props) {
    super(props);
    this.goToDealPage = this.goToDealPage.bind(this);
  }

  goToDealPage() {
    if (this.props.dealDetails.dealId){
      window.open(`/deals/${this.props.dealDetails.dealId}`, "_blank")
    }
  }

  render() {
    if (this.props.dealDetails && this.props.dealDetails.imageUrl){
      return (
        <img class="deal-image" src={this.props.dealDetails.imageUrl} onClick={this.goToDealPage} alt="Deal Image"/>
      );
    }
    return null;
  }
}
module.exports = DealImage
